<template>
  <v-row no-gutters class="row data-gutters" style="cursor:pointer;">
    <v-col cols="10" md="10">
      <v-card class="pa-2" v-bind:elevation="0" align-self="center">
        <v-list-item three-line class="px-2">
          <v-list-item-avatar width="50px" height="50px" @click="showUerProfile"> 
            <img v-bind:src="userImage" class="fitImage">
          </v-list-item-avatar>
          <v-list-item-content  @click="showDetail(vacationInfo.id)">
            <v-list-item-title >
              <b>{{ userName }}</b>
            </v-list-item-title>
            <v-list-item-subtitle  style="height: 20px;">
              <span v-bind:style="statusColor" style="font-size: 0.85em;">{{ vacationStatus }}</span>
              <span  v-if="vacationInfo.all_day == 1">
                <span v-show="getWorkFromHome(vacationInfo)" :class="[getWorkFromHome(vacationInfo) ? 'questionColor' : 'timeColor']" style="margin-left: 15px;margin-right: -5px;">{{ $t("icon_wfh") }}</span>
                <span v-show="getOnsite(vacationInfo)" :class="[getOnsite(vacationInfo) ? 'questionColor' : 'timeColor']" style="margin-left: 15px;margin-right: -5px;">{{ $t("icon_onsite") }}</span>
                <span v-show="getTimeObject(vacationInfo).startTime !=''" :class="[getTimeObject(vacationInfo).startTime=='?' ? 'questionColor'  : 'timeColor']" style="margin-left: 15px;">{{ getTimeObject(vacationInfo).startTime }} </span>
                <span v-show="getTimeObject(vacationInfo).startTime !=''" style="color: #C7C7C7; margin-left: 3px;">- </span>
                <span v-show="getTimeObject(vacationInfo).endTime !=''" :class="[getTimeObject(vacationInfo).endTime=='?' ? 'questionColor'  : 'timeColor']">{{ getTimeObject(vacationInfo).endTime }}</span>
              </span>  
              <span v-else>
                <span v-show="getWorkFromHome(vacationInfo)" :class="[getWorkFromHome(vacationInfo) ? 'questionColor' : 'timeColor']" style="margin-left: 15px;">{{ $t("icon_wfh") }}</span>
                <span v-show="getOnsite(vacationInfo)" :class="[getOnsite(vacationInfo) ? 'questionColor' : 'timeColor']" style="margin-left: 15px;">{{ $t("icon_onsite") }}</span>
              </span> 
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-card>
    </v-col>
    <v-col cols="2" md="2" align-self="center" @click="showDetail(vacationInfo.id)" >
      <v-card class="pa-2" :elevation="0" >
        <v-list-item two-line style="position:relative;">
          <v-list-item-content style="width:200px;" v-if="!(vacationType == VacationDetailType.AllDay_OneDay)">
            <div class="day-label"
              v-if="vacationType == VacationDetailType.AllDay_MultiDay || vacationType == VacationDetailType.ByTime_MultiDay">
              <span class="day-span">{{ $t("filter_fromdate") + ":" }}</span><br>
              <span class="day-span">{{ $t("filter_todate") + ":" }}</span>
            </div>
            <div class="day-value"><span>{{ startDateString }}</span><br><span> {{ endDateString }}</span></div>
          </v-list-item-content>
          <v-list-item-content style="width:200px;" v-if="vacationType == VacationDetailType.AllDay_OneDay">
            <v-list-item-subtitle>
              <span class="date-value">{{ startDateString }} </span>
              <span class="date-label">{{ endDateString }}</span>
            </v-list-item-subtitle>
          </v-list-item-content>

          <v-list-item-content style="position:absolute; ">
            <router-link style="text-decoration: none" to=""  class="pr-3 pr-md-13 icon-detail">
              <v-icon color="blue">mdi-chevron-right</v-icon>
              </router-link>
          </v-list-item-content>
        </v-list-item>
      </v-card>
    </v-col>
    <v-col cols="12" class="line ml-2"></v-col>
  </v-row>
</template>

<script>
import {
  DefaultValues,
  getVacationStatusText,
  getVacationStatusColor,
  ListEvents,
  compareVacationDate
} from "@/utilities/CommonUtilities";
import { mapGetters, mapState } from "vuex";

const VacationDetailType = {
  AllDay_MultiDay: "0",
  AllDay_OneDay: "1",
  ByTime_MultiDay: "2",
  ByTime_OneDay: "3"
};

export default {
  props: ["vacationInfo", "vacationDate", "isDateRangeFilter"],
  data: () => ({
    VacationDetailType,
    showFilter: false,
    typeName: null,
    reasonName: null,
    statusColor: {
      color: "#000000"
    },
    reasonInfo: {},
    userInfo: {},
    startDateString: null,
    endDateString: null,
    vacationType: null
  }),
  computed: {
    ...mapGetters(["getTypeAndReasonByReasonID", "getUserByID"]),
    ...mapState({
      tabSelecting: (state) => state.homeData.currentTab,
    }),
    userImage() {
      if (this.userInfo && this.userInfo.profiolePhoto != null) {
        return `data:image/png;base64,${this.userInfo.profiolePhoto}`;
      } else {
        return DefaultValues.no_image;
      }
    },
    section() {
      return (
        this.$i18n.t("common_section") +
        ": " +
        (this.userInfo != null
          ? this.userInfo.section
          : DefaultValues.none_string)
      );
    },
    userName() {
      return this.userInfo == null
        ? DefaultValues.none_string
        : this.userInfo.name;
    },
    vacationStatus() {
      let status;
      if (this.vacationInfo && this.vacationInfo.status) {
        status = getVacationStatusText(
          this.vacationInfo.status,
          this.$i18n.locale
        );
      }

      return status;
    }
  },
  methods: {
    showDetail(vacationID) {
      this.notifyBus.$emit(ListEvents.showVacationDetail, vacationID);
    },
    showUerProfile() {
      this.$router.push({
        name: "profile",
        params: {
          userid: this.vacationInfo.user_id
        }
      });
    },
    formatTime(dateTime) {
      return dateTime.split(' ')[1].slice(0, 5);
    },
    formatDate(dateTime) {
      return dateTime.split(' ')[0];
    },
    getTimeObject(vacationInfo) {
      const fromDate = vacationInfo.from_date.split(' ')[0];
      const toDate = vacationInfo.to_date.split(' ')[0];
      const fromTime = this.formatTime(vacationInfo.from_date);
      const toTime = this.formatTime(vacationInfo.to_date);
      if(fromDate == toDate){
        return { startTime: fromTime, endTime: toTime };
      } else if (fromDate !== toDate && this.formatDate(vacationInfo.from_date) === this.vacationDate) {
        return { startTime: fromTime, endTime: '?' };
      } else if ( fromDate !== toDate && this.formatDate(vacationInfo.to_date) === this.vacationDate) {
        return { startTime: '?', endTime: toTime };
      } else {
        return { startTime: '', endTime: '' };
      }
    },
    getWorkFromHome(vacationInfo) {
      const typeId = vacationInfo.type_id;
      const reasonId = vacationInfo.reason_id;

      if (typeId === 6 && reasonId === 37) {
        return true;
      }
      return false; 
    },
    getOnsite(vacationInfo) {
      const typeId = vacationInfo.type_id;
      const reasonId = vacationInfo.reason_id;

      if (typeId === 6 && reasonId === 38) {
        return true;
      }
      return false; 
    }
  },
  created() {
    let typeAndReasonInfo = this.getTypeAndReasonByReasonID(
      this.vacationInfo.reason_id
    );
    if (typeAndReasonInfo != null) {
      if (this.$i18n.locale == "ja") {
        this.typeName = typeAndReasonInfo.type.name_jp;
        this.reasonName = typeAndReasonInfo.reason.name_jp;
      } else if (this.$i18n.locale == "vi") {
        this.typeName = typeAndReasonInfo.type.name_vi;
        this.reasonName = typeAndReasonInfo.reason.name_vi;
      } else {
        this.typeName = typeAndReasonInfo.type.name_en;
        this.reasonName = typeAndReasonInfo.reason.name_en;
      }
      this.reasonInfo = typeAndReasonInfo.reason;
    }
    this.statusColor.color = getVacationStatusColor(this.vacationInfo.status);
    if (this.isDateRangeFilter == "1") {
      if (
        compareVacationDate(
          this.vacationInfo.from_date,
          this.vacationInfo.to_date
        ) == -1
      ) {
        this.statusColor.color = "#C7C7C7";
      }
    }

    this.userInfo = this.getUserByID(this.vacationInfo.user_id);
  },
  watch: {
    vacationInfo: {
      handler(value) {
        this.statusColor.color = getVacationStatusColor(value.status);
        if (this.isDateRangeFilter == "1") {
          if (
            compareVacationDate(
              this.vacationInfo.from_date,
              this.vacationInfo.to_date
            ) == -1
          ) {
            this.statusColor.color = "#C7C7C7";
          }
        }
      },
      deep: true
    }
  },
  inject: ["notifyBus"]
};
</script>

<style scoped>
.text-center {
  flex-direction: column;
  text-align: center;
  align-content: center;
}

.v-list-item__title {
  font-size: 0.875rem;
  font-weight: bold;
}

.v-list-item .v-list-item__title span {
  font-size: 0.75rem;
  margin-left: 10px;
}

span.member-infor-list {
  font-size: 0.75rem;
  color: #c7c7c7;
}

span.date-label {
  color: #333333;
  margin-right: 5px;
}
.date-value {
  font-weight: bold;
  color: #333333;
  text-align: right;
}
.date-suffix {
  margin-left: 6px;
}

.v-application a {
  color: #5e81ed;
  font-size: 0.875rem;
  font-weight: bold;
  width: 70px;
}

.v-application .pa-2 {
  padding: 0px !important;
}

.line {
  box-shadow: 0 0.5px 0 #c7c7c7;
  height: 1px;
}

.col {
  padding: 0px 12px;
  margin-bottom: 1px;
}

.v-list-item__content > *:not(:last-child) {
  margin-bottom: 5px;
}

.v-list--two-line .v-list-item,
.v-list-item--two-line {
  min-height: 40px;
}

.v-list-item--three-line {
  min-height: 80px;
}

.v-list-item--three-line .v-list-item__content {
  align-self: inherit;
}

.v-list-item__content {
  padding: 4px 0;
  display: inline-table;
}

.fitImage {
  object-fit: cover;
  cursor:pointer;
}

.day-label {
  height: 100%;
  float: left;
  font-size: 0.875rem;
  line-height: 1.5;
}

.day-value {
  height: 100%;
  width: 200px;
  font-size: 0.875rem;
  color: #333333;
  line-height: 1.5;
  font-weight: bold;
}

.day-span {
  display: inline-block;
  margin-right: 10px;
}

::v-deep .col {
    padding: 0px 12px;
    margin-bottom: 2px;
    margin-top: -6px;
    z-index: 5;
    border-bottom: 1px solid rgba(128, 128, 128, 0.5);
    transform: scaleY(0.5);
}

@media (max-width: 767px) {
  .data-gutters {
    margin-bottom: -13px !important;
  }
  @media (orientation: landscape){
    .icon-detail {
    margin-left: 45px !important;
  }
};
}
.v-icon.v-icon {
  font-size: 24px;
  margin-left: 18px;
}

.timeColor {
    color: #FFFFFF;
    font-weight: bold;
    background-color: #C7C7C7;
    border-radius: 8px;
    padding-left: 5px;
    padding-right: 5px;
    padding-bottom: 3px;
    padding-top: 3px;
    font-size: 0.75em;
    text-align: center;
    display: inline-block;
  }

  .questionColor {
    color: #FFFFFF;
    font-weight: bold;
    background-color: #C7C7C7;
    border-radius: 8px;
    padding-left: 8px;
    padding-right: 8px;
    padding-bottom: 3px;
    padding-top: 3px;
    font-size: 0.75em;
    text-align: center;
    display: inline-block;
  }
</style>
